// Estados del proceso (campo `status` de la vacante).
//
// Abiertos:
//   draft     — aún no publicada
//   active    — ÚNICO estado que publica la vacante y recibe postulaciones
//               (portal público, job board y bot de captación)
//   suspended — pausa temporal, se retomará; deja de recibir postulaciones
//               pero el pipeline sigue editable
// Terminales:
//   closed    — el proceso terminó y la vacante se cubrió
//   cancelled — el cargo ya no se necesita, se da de baja la búsqueda
//
// El allow-list equivalente del backend está en
// `server/src/validators/positions.validator.js` (validatePositionStatus).
export const STATUSES = ['draft', 'active', 'suspended', 'closed', 'cancelled'];

// Estados que dan por terminado el proceso: congelan el pipeline (no se avanzan
// fases ni se cambian etapas de candidatos).
export const TERMINAL_STATUSES = ['closed', 'cancelled'];

export const isTerminalStatus = (status) => TERMINAL_STATUSES.includes(status);

// Color del Chip de MUI por estado. La etiqueta sale de i18n:
// `ats.positions.wizard.options.status.<status>`.
const STATUS_COLORS = {
  draft: 'default',
  active: 'success',
  suspended: 'warning',
  closed: 'info',
  cancelled: 'error',
};

export const getStatusColor = (status) => STATUS_COLORS[status] || STATUS_COLORS.draft;

// Etiqueta traducida, con fallback a "Borrador" para valores desconocidos
// (ej. el legacy 'confidential' de vacantes antiguas).
export const getStatusLabel = (status, t) =>
  t(`ats.positions.wizard.options.status.${STATUS_COLORS[status] ? status : 'draft'}`);

// "Visible en portal" (switch de la vacante, captacion.portalEnabled). Apagado:
// la vacante no sale en la web de empleos y su link no recibe postulaciones
// (PLAN_MASIVO_PORTAL). Si nunca se guardó: las masivas antiguas quedan fuera y
// las hunting siguen el antiguo "Tipo de publicación" (No publicada = fuera).
// Misma regla que el backend (captationPortal.utils → isVisibleInPortal).
export const isVisibleInPortal = (position) => {
  if (!position) return false;
  const flag = position.captacion?.portalEnabled;
  if (typeof flag === 'boolean') return flag;
  if (position.tipo === 'massive') return false;
  return position.tipoPublicacion !== 'unpublished';
};
